import { render, staticRenderFns } from "./newMessage.vue?vue&type=template&id=3c2a5c7a&scoped=true"
import script from "./newMessage.vue?vue&type=script&lang=js"
export * from "./newMessage.vue?vue&type=script&lang=js"
import style0 from "./newMessage.vue?vue&type=style&index=0&id=3c2a5c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2a5c7a",
  null
  
)

export default component.exports